import React from "react";
import {
  VegaFlex,
  VegaFont,
  VegaIcon,
  VegaBox,
} from "@heartlandone/vega-react";

function ActivityAddress({ online, city, address }) {
  return (
    <VegaFlex gap={"size-12"}>
      <VegaBox width="size-16" height="size-16" style={{ textAlign: "center", lineHeight: '16px' }}>
        <VegaIcon
          icon={online ? "fal fa-presentation-screen" : "fal fa-location-dot"}
          size="size-16"
          color="text-secondary"
        ></VegaIcon>
      </VegaBox>
      <VegaFont color="text-secondary" variant="font-field-value-sm">
        {online ? "Online Activity" : `${city} - ${address}`}
      </VegaFont>
    </VegaFlex>
  );
}

export default ActivityAddress;
